import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FaqPageComponent, PageNotFoundComponent } from '@campus/public-portal';
import { PortalHeaderComponent } from './components/header/header.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LegalsPageContainerComponent } from './pages/legals-page/legals-page-container.component';
import { LoginComponent } from './pages/login/login.component';

const routes: Routes = [
  { path: '', outlet: 'header', component: PortalHeaderComponent },

  {
    path: '',
    runGuardsAndResolvers: 'always',
    component: HomePageComponent,
  },
  {
    path: 'login/:role',
    runGuardsAndResolvers: 'always',
    component: LoginComponent,
  },

  {
    path: 'faq',
    component: FaqPageComponent,
  },
  {
    path: 'legals/:slug',
    component: LegalsPageContainerComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
